import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView02ImageOptions } from './views/ExteriorView02'

class Xr41BowSprit extends Component {
  constructor (props) {
    super(props)
    this.state = { overlayUrls: [] }
    this.handleBowSpritChange = this.handleBowSpritChange.bind(this)
    this.handleOverlayUrls = this.handleOverlayUrls.bind(this)
  }

  handleOverlayUrls (urls) {
    const current = this.state.overlayUrls
    if (urls.length !== current.length || urls.some((u, i) => u !== current[i])) {
      this.setState({ overlayUrls: urls })
    }
  }

  handleBowSpritChange (newValue) {
    let configuration = this.props.configuration
    configuration.Bowsprit = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

    render() {
        let imageOptions = exteriorView02ImageOptions;

    let image = (
      <div style={{ position: 'relative' }}>
        <ConfiguratorImage
          boat='Xr41'
          configuration={this.props.configuration}
          options={imageOptions}
          onOverlayUrls={this.handleOverlayUrls}
        />
        {this.state.overlayUrls.length > 0 && (
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 10 }}>
            {this.state.overlayUrls.map((url) => (
              <img key={url} src={url} alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', objectFit: 'contain' }} />
            ))}
          </div>
        )}
      </div>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Bowsprit' />
          </h1>

          <p>
              <Trans defaults='XR 41 Sport comes with a shorter bowsprit (1 metre shorter than the Race version) which simplifies harbour manoeuvres and sail handling, especially in tighter marinas. ' />
          </p>

           <p>
                    <Trans defaults='The XR 41 Race sail plan is built around asymmetrical downwind sails, flown from a relatively long bowsprit, delivering strong performance and control at high boat speed.  ' />
           </p>

                      <p>
                    <Trans defaults='The shorter sport bow sprit can accommodate the optional anchor arm and anchor winch. ' />
           </p>

          <RadioGroup
            label={this.props.t('Bowsprit options:')}
            options={this.props.bowSpritOptions}
            value={this.props.configuration.Bowsprit}
            onChange={this.handleBowSpritChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41BowSprit)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41BowSprit.js